import { KeyValue } from '@/main/models/common';

export enum QuoteStatusTypes {
  GET_QUOTE_STATUS = '@company/GET_QUOTE_STATUS',
  SAVE_QUOTE_STATUS = '@company/SAVE_QUOTE_STATUS',
  RESET_REDUCER_QUOTE_STATUS = '@company/RESET_REDUCER_QUOTE_STATUS',
  GET_DOMAIN_QUOTE_STATUS = '@quoteStatus/GET_DOMAIN_QUOTE_STATUS'
}

export interface QuoteStatusState {
  readonly quoteStatus: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetQuoteStatus {
  type: typeof QuoteStatusTypes.GET_QUOTE_STATUS;
  payload?: {
    isUserControl: boolean | null;
  };
}

export interface SaveQuoteStatus{
  type: typeof QuoteStatusTypes.SAVE_QUOTE_STATUS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerQuoteStatus {
  type: typeof QuoteStatusTypes.RESET_REDUCER_QUOTE_STATUS;
}

export interface GetDomainQuoteStatus {
  type: typeof QuoteStatusTypes.GET_DOMAIN_QUOTE_STATUS;
  payload: {
    keyReducer: string;
  }
}

export type QuoteStatusActionTypes =
  | GetQuoteStatus
  | SaveQuoteStatus
  | ResetReducerQuoteStatus
  | GetDomainQuoteStatus;
